import '.f0{transition:all .2s ease-out;}.ssr-plugin'
import '.f5{margin:-8px -16px;}.ssr-plugin'
import '.f6{padding:8px 16px;}.ssr-plugin'
import '.f7{border-radius:24px;}.ssr-plugin'
import '.f8{border:1px solid transparent;}.ssr-plugin'
import '.f1{scale:1;}.ssr-plugin'
import '.bi{max-width:480px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.k{height:100%;}.ssr-plugin'
import '.es{margin-left:8px;}.ssr-plugin'
import '.et{margin-right:8px;}.ssr-plugin'
import '.eu{max-height:calc(100vh - 192px);}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.cx{border-radius:24px;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.ee{backdrop-filter:blur(48px);}.ssr-plugin'
import '.ef{-webkit-backdrop-filter:blur(48px);}.ssr-plugin'
import '.cv{flex-direction:row;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.ev{padding:20px 24px;}.ssr-plugin'
import '.ew{font-size:20px;}.ssr-plugin'
import '.ex{margin-top:4px;}.ssr-plugin'
import '.ey{overflow-y:scroll;}.ssr-plugin'
import '.ac{scrollbar-width:none;}.ssr-plugin'
import '.h{flex:1;}.ssr-plugin'
import '.bl{margin-bottom:16px;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import '.ez{margin:24px auto;}.ssr-plugin'
import '.cb{gap:16px;}.ssr-plugin'
import { useQuery } from '@based'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { IconButton } from './IconButton.js'
import { Icon } from '../assets/icons/index.js'
import {
  useVotingRegion,
  useVotingRegionName,
  getVotingRegionName,
} from '../hooks/useVotingRegion.js'
import { ModalWrapper, MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { MOBILE } from '../utils/breakpoints.js'
import { useTranslations } from '../hooks/useTranslations.js'
import { useLanguage } from '../hooks/useLanguage.js'
import { useLocation } from 'wouter'
import { defaultRegion } from '../hooks/useSelectedVotingRegion.js'

const VotingRegionItem = ({ code, onSelect }) => {
  const name = useVotingRegionName(code)
  return (
    <styled.a className="f0 f5 f6 f7 f8 f1"
      id={`language-modal-action-set-voting-region-${code}`}
      style={{
        '&:hover': {
          background: `${colors.border}`,
          border: `1px solid ${colors.border}`,
          scale: '.98',
        },
      }}
      onClick={onSelect}
    >
      {name} <Icon type="chevronRightIcon" />
    </styled.a>
  )
}

export const SelectVotingRegionModal = ({ setModal }) => {
  const track = useTrack('menu')
  const [votingRegion, setVotingRegion] = useVotingRegion()

  const { data: navigationTranslation } = useTranslations('Navigation')
  const [lang] = useLanguage()

  const [location, setLocation] = useLocation()

  const { data: participatingVotingRegions } = useQuery(
    'participating-voting-regions',
  )

  const votingRegionsCodes =
    participatingVotingRegions &&
    Object.keys(participatingVotingRegions)
      .filter((item) => !participatingVotingRegions[item].isTerritoryOf)
      .sort((a, b) =>
        getVotingRegionName(a, lang.code).localeCompare(
          getVotingRegionName(b, lang.code),
          lang.code,
        ),
      )

  return (
    <ModalWrapper onDismiss={() => setModal(false)}>
      <styled.div className="bi m k es et eu b1 cx e f ee ef"
        style={{
          backgroundColor: `${transparentColor(colors.secondary, 0.1)}`,
          border: `1px solid ${colors.border}`,
          animation: MODAL_PANEL_ANIMATION,
          [MOBILE]: {
            maxHeight: 'calc(100vh - 16px)',
            backgroundColor: `${transparentColor(colors.secondary, 0.8)}`,
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
          },
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div className="e cv ao w ev"
          style={{
            borderBottom: `1px solid ${colors.border}`,
          }}
        >
          <h3 className="ew ex">
            {navigationTranslation?.selectVotingRegion}
          </h3>
          <IconButton
            id="voting-region-modal-action-close-button"
            variant="ghost"
            icon={<Icon type="closeIcon" />}
            onClick={() => setModal(false)}
          />
        </div>
        <styled.div className="ey ac h ev"
          style={{
            '& a': {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              userSelect: 'none',
            },
          }}
        >
          <p className="subtext bl bo"
          >
            {navigationTranslation?.basedOnYourLocation}
          </p>
          <styled.a className="f0 f5 f6 f7 f8 f1"
            style={{
              '&:hover': {
                background: `${colors.border}`,
                border: `1px solid ${colors.border}`,
                scale: '.98',
              },
            }}
            onClick={() => {
              track(
                AnalyticsEvent.MENU_REGION_CHANGE,
                `${votingRegion.code}->ROW`,
              )
              setVotingRegion('ROW')
              setModal(false)
              setLocation('/')
            }}
          >
            {getVotingRegionName(defaultRegion, lang.code)}
            <Icon type="chevronRightIcon" />
          </styled.a>
          <div className="m ez"
            style={{
              backgroundColor: colors.border,}}
          />
          <p className="subtext bl bo"
          >
            {navigationTranslation?.allVotingRegions}
          </p>
          <div className="e f cb"
          >
            {votingRegion?.code !== 'ROW' && (
              <VotingRegionItem
                code={'ROW'}
                onSelect={() => {
                  track(
                    AnalyticsEvent.MENU_REGION_CHANGE,
                    `${votingRegion.code}->ROW`,
                  )
                  setVotingRegion('ROW')
                  setModal(false)
                  setLocation('/')
                }}
              />
            )}
            {votingRegionsCodes
              ?.filter((item) => item !== 'ROW')
              ?.map((item) => (
                <VotingRegionItem
                  key={item}
                  code={item}
                  onSelect={() => {
                    track(
                      AnalyticsEvent.MENU_REGION_CHANGE,
                      `${votingRegion.code}->${item}`,
                    )
                    setVotingRegion(item)
                    setModal(false)
                    setLocation('/')
                  }}
                />
              ))}
          </div>
        </styled.div>
      </styled.div>
    </ModalWrapper>
  )
}
